module.exports = __webpack_public_path__ + "img/Frame-15.31750326.jpg";